/**
 * Authored cool-steel surface palette applied once on ThemeStore init.
 *
 * The rainbow surface picker (slate/gray/zinc/…) was retired with the theme
 * configurator. Brands supply their own instrument ramp via
 * {@link import('./theme.brand-tokens').THEME_BRAND_TOKENS}; this fallback
 * matches the Indutrust instrument ramp for tests without a brand layer.
 *
 * Light `50` is a cool near-white wash so white cards (`0`) still lift.
 * Dark `950` is near-black with a tiny cool tint (not blue-washed).
 */
export const INSTRUMENT_SURFACE_PALETTE: Record<string, string> = {
  0: '#ffffff',
  50: '#f1f5fa',
  100: '#e8eef6',
  200: '#d0dae8',
  300: '#a8b6c9',
  400: '#7c8fa8',
  500: '#617488',
  600: '#3d424e',
  700: '#2e323c',
  800: '#1a1d26',
  900: '#12141a',
  950: '#08090c',
};
